// Centralized currency formatter — all Rowen Kids Club prices are CAD.
export const fmtCAD = (n) => `CA$${Number(n || 0).toFixed(2)}`;
